import { useBreakpointValue } from '@chakra-ui/react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const MarksProjectChart = ({ data }) => {
	// Calculate the total marks
	const totalMarks = data.reduce((acc, project) => acc + parseFloat(project.total_marks), 0);

	const isMobile = useBreakpointValue({ base: true, md: false });

	const width = useBreakpointValue({ base: 300, md: 660 });
	const height = useBreakpointValue({ base: 300, md: 500 });

	// Define colors
	const colors = [
		'#f3a683', '#f7d794', '#dbe5d8', '#b9e3c6', '#b0e57c',
		'#ff9f9f', '#c6a0f0', '#76e3f0', '#f0b9e0', '#9de0a4',
	];

	// Prepare data for the chart
	const chartOptions = {
		chart: {
			type: 'column',
			backgroundColor: 'transparent',
			width: width,
			height: height,
			animation: false, // Disable animations
		},
		title: {
			text: 'Total Marks by Projects',
			style: {
				fontSize: !isMobile ? '20px' : "14px",
			},
		},
		xAxis: {
			categories: data.map(project => project.name),
			title: {
				text: null,
			},
		},
		yAxis: {
			min: 0,
			title: {
				text: 'Total Marks',
			},
		},
		colors: colors,
		series: [{
			name: 'Marks',
			colorByPoint: true,
			data: data.map((project) => {
				const marks = parseFloat(project.total_marks);
				const percentage = totalMarks > 0 ? (marks / totalMarks) * 100 : 0;
				return {
					y: marks,
					percentage: percentage,
				};
			}),
			dataLabels: {
				enabled: true,
				formatter: function () {
					return `${this.point.percentage.toFixed(2)}%`;
				}
			},
		}],
		plotOptions: {
			column: {
				dataLabels: {
					enabled: true,
				},
				pointWidth: !isMobile ? 30 : 20,
				groupPadding: 0.1,
				pointPadding: 0.2,
			},
		},
		legend: {
			enabled: false,
		},
		exporting: {
			enabled: false,
		},
		credits: {
			enabled: false,
		},
	};

	return (
		<HighchartsReact
			highcharts={Highcharts}
			options={chartOptions}
		/>
	);
};

export default MarksProjectChart;
